var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "general/idcard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F8F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5ZM20 5L4 5V19H20V5ZM10 9.5H5.5V7.5H10V9.5ZM10 13H5.5V11H10V13ZM8 16.5H5.5V14.5H8V16.5ZM14.5 14C13.1193 14 12 15.1193 12 16.5H10C10 14.6631 11.1007 13.0832 12.6785 12.3839C11.9621 11.8357 11.5 10.9718 11.5 10C11.5 8.34315 12.8431 7 14.5 7C16.1569 7 17.5 8.34315 17.5 10C17.5 10.9718 17.0379 11.8357 16.3215 12.3839C17.8993 13.0832 19 14.6631 19 16.5H17C17 15.1193 15.8807 14 14.5 14ZM13.5 10C13.5 9.44772 13.9477 9 14.5 9C15.0523 9 15.5 9.44772 15.5 10C15.5 10.5523 15.0523 11 14.5 11C13.9477 11 13.5 10.5523 13.5 10Z",
    fill: "#6F52ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.131f212bd997a5f298e4559a569c10ca.svg";
export { ForwardRef as ReactComponent };